import React from "react";
import classnames from "classnames";
import BottomNavigation from "@material-ui/core/BottomNavigation";

import { makeStyles } from "@material-ui/core/styles";
import MyBottomNavigationAction from "../../UI/MyBottomNavigationAction/MyBottomNavigationAction";
import home_active from "../../../assets/icons/footer/home_active.svg";
import more_active from "../../../assets/icons/footer/more_active.svg";
import offersIcon from "../../../assets/icons/footer/offersIcon.svg";
import redeem_active from "../../../assets/icons/footer/redeem_active.svg";
import transactions_active from "../../../assets/icons/footer/transactions_active.svg";
import { connect } from "react-redux";
import { changeActiveTab, logoutUser } from "../../../App/redux/action";

const useStyles = makeStyles((theme) => {
  return {
    bottomNav: {
      width: "100%",
      padding: 0,
      alignItems: "center",
      justifyContent: "center",
      zIndex: 999,
      position: "fixed",
      bottom: 0,
      height: "calc(86px + env(safe-area-inset-bottom))",
      // boxShadow: "0px -1px 3px 0 rgba(0, 0, 0, 0.3)",
      // paddingBottom: "env(safe-area-inset-bottom)",
      backgroundColor: '#F5F5F5',
      // [theme.breakpoints.down("641")]: {
      //   height: "98px",
      // },
      // [theme.breakpoints.down("481")]: {
      //   height: "calc(68px + env(safe-area-inset-bottom))",
      // },
      // [theme.breakpoints.down("421")]: {
      //   height: "calc(68px + env(safe-area-inset-bottom))",
      // },
      // [theme.breakpoints.down("381")]: {
      //   height: "calc(64px + env(safe-area-inset-bottom))",
      // },
      // [theme.breakpoints.down("361")]: {
      //   height: "calc(60px + env(safe-area-inset-bottom))",
      // },
      // [theme.breakpoints.down("321")]: {
      //   height: "59px",
      // },

      [theme.breakpoints.down("641")]: {
        height: "98px",
      },
      [theme.breakpoints.down("481")]: {
        height: "80px",
      },
      [theme.breakpoints.down("421")]: {
        height: "72px",
      },
      [theme.breakpoints.down("381")]: {
        height: "72px",
      },
      [theme.breakpoints.down("361")]: {
        height: "72px",
      },
      [theme.breakpoints.down("321")]: {
        height: "59px",
      },
    },
    icon: {
      width: "36px",
      height: "36px",
      display: "inline-block",
      transition: ".12s",
      "-webkit-mask-size": "cover",
      "mask-size ": "cover",
      objectFit: "contain",
      objectPosition: "center",
      marginBottom: "11px",
      [theme.breakpoints.down("481")]: {
        width: "25px",
        height: "25px",
        marginBottom: "6px",
      },
      [theme.breakpoints.down("381")]: {
        width: "18px",
        height: "18px",
      },
      [theme.breakpoints.down("321")]: {
        width: "16px",
        height: "16px",
      },
    },
    moreIcon: {
      margin: "15px 0px 26px 0px",
      width: "36px",
      height: "6px",
      objectFit: "contain",
      objectPosition: "center",
      [theme.breakpoints.down("481")]: {
        width: "25px",
        height: "5px",
        margin: "10px 0px 16px 0px",
      },
      [theme.breakpoints.down("381")]: {
        width: "16px",
        height: "5px",
        margin: "7px 0px 13px 0px",
      },
      [theme.breakpoints.down("321")]: {
        width: "16px",
        height: "3px",
        margin: "6px 0px 12px 0px",
      },
    },
    transactionsIcon: {
      width: "30px",
      height: "38px",
      objectFit: "contain",
      objectPosition: "center",
      marginBottom: "11px",
      [theme.breakpoints.down("481")]: {
        width: "20px",
        height: "26px",
        marginBottom: "6px",
      },
      [theme.breakpoints.down("381")]: {
        width: "16px",
        height: "19px",
      },
      [theme.breakpoints.down("321")]: {
        width: "14px",
        height: "17px",
      },
    },

    home_active: {
      background: 'linear-gradient(129.99deg, #7D5200 -19.62%, #FFAD11 52.28%, #7D5200 124.19%)',
      "-webkit-mask-image": `url(..${home_active})`,
      "mask-image": `url(..${home_active})`,
      mask: `url(..${home_active}) no-repeat center / contain`,
      "-webkit-mask": `url(..${home_active}) no-repeat center / contain`,
    },
    home_deactive: {
      background: 'linear-gradient(129.99deg, #7D5200 -19.62%, #FFAD11 52.28%, #7D5200 124.19%)',
      "-webkit-mask-image": `url(..${home_active})`,
      "mask-image": `url(..${home_active})`,
      mask: `url(..${home_active}) no-repeat center / contain`,
      "-webkit-mask": `url(..${home_active}) no-repeat center / contain`,
    },
    redeem_active: {
      background: 'linear-gradient(129.99deg, #7D5200 -19.62%, #FFAD11 52.28%, #7D5200 124.19%)',
      "-webkit-mask-image": `url(..${redeem_active})`,
      "mask-image": `url(..${redeem_active})`,
      mask: `url(..${redeem_active}) no-repeat center / contain`,
      "-webkit-mask": `url(..${redeem_active}) no-repeat center / contain`,
    },
    redeem_deactive: {
      background: 'linear-gradient(129.99deg, #7D5200 -19.62%, #FFAD11 52.28%, #7D5200 124.19%)',
      "-webkit-mask-image": `url(..${redeem_active})`,
      "mask-image": `url(..${redeem_active})`,
      mask: `url(..${redeem_active}) no-repeat center / contain`,
      "-webkit-mask": `url(..${redeem_active}) no-repeat center / contain`,
    },
    // perks_active: {
    //   backgroundColor: theme.palette.footer.activeIcon,
    //   "-webkit-mask-image": `url(..${giftIcon})`,
    //   "mask-image": `url(..${giftIcon})`,
    //   mask: `url(..${giftIcon}) no-repeat center / contain`,
    //   "-webkit-mask": `url(..${giftIcon}) no-repeat center / contain`,
    // },
    // perks_deactive: {
    //   backgroundColor: theme.palette.footer.inactiveIcon,
    //   "-webkit-mask-image": `url(..${giftIcon})`,
    //   "mask-image": `url(..${giftIcon})`,
    //   mask: `url(..${giftIcon}) no-repeat center / contain`,
    //   "-webkit-mask": `url(..${giftIcon}) no-repeat center / contain`,
    // },
    offers_active: {
      background: 'linear-gradient(129.99deg, #7D5200 -19.62%, #FFAD11 52.28%, #7D5200 124.19%)',
      "-webkit-mask-image": `url(..${offersIcon})`,
      "mask-image": `url(..${offersIcon})`,
      mask: `url(..${offersIcon}) no-repeat center / contain`,
      "-webkit-mask": `url(..${offersIcon}) no-repeat center / contain`,
    },
    offers_deactive: {
      background: 'linear-gradient(129.99deg, #7D5200 -19.62%, #FFAD11 52.28%, #7D5200 124.19%)',
      "-webkit-mask-image": `url(..${offersIcon})`,
      "mask-image": `url(..${offersIcon})`,
      mask: `url(..${offersIcon}) no-repeat center / contain`,
      "-webkit-mask": `url(..${offersIcon}) no-repeat center / contain`,
    },
    more_active: {
      background: 'linear-gradient(129.99deg, #7D5200 -19.62%, #FFAD11 52.28%, #7D5200 124.19%)',
      "-webkit-mask-image": `url(..${more_active})`,
      "mask-image": `url(..${more_active})`,
      mask: `url(..${more_active}) no-repeat center / contain`,
      "-webkit-mask": `url(..${more_active}) no-repeat center / contain`,
    },
    more_deactive: {
      background: 'linear-gradient(129.99deg, #7D5200 -19.62%, #FFAD11 52.28%, #7D5200 124.19%)',
      "-webkit-mask-image": `url(..${more_active})`,
      "mask-image": `url(..${more_active})`,
      mask: `url(..${more_active}) no-repeat center / contain`,
      "-webkit-mask": `url(..${more_active}) no-repeat center / contain`,
    },
    transactions_active: {
      background: 'linear-gradient(129.99deg, #7D5200 -19.62%, #FFAD11 52.28%, #7D5200 124.19%)',
      "-webkit-mask-image": `url(..${transactions_active})`,
      "mask-image": `url(..${transactions_active})`,
      mask: `url(..${transactions_active}) no-repeat center / contain`,
      "-webkit-mask": `url(..${transactions_active}) no-repeat center / contain`,
    },
    transactions_deactive: {
      background: 'linear-gradient(129.99deg, #7D5200 -19.62%, #FFAD11 52.28%, #7D5200 124.19%)',
      "-webkit-mask-image": `url(..${transactions_active})`,
      "mask-image": `url(..${transactions_active})`,
      mask: `url(..${transactions_active}) no-repeat center / contain`,
      "-webkit-mask": `url(..${transactions_active}) no-repeat center / contain`,
    },
  };
});

const Footer = (props) => {
  const classes = useStyles();
  const routes = [
    {
      name: "Home",
      link: "/",
      value: 0,
      iconPath: classes.home_deactive,
      iconActive: classes.home_active,
    },
    {
      name: "Offers",
      link: "/offers",
      value: 1,
      iconPath: classes.offers_deactive,
      iconActive: classes.offers_active,
    },
    {
      name: "Redeem",
      link: "/redeem",
      value: 2,
      iconPath: classes.redeem_deactive,
      iconActive: classes.redeem_active,
    },
    {
      name: "Transactions",
      link: "/transactions",
      value: 3,
      iconPath: classes.transactions_deactive,
      iconActive: classes.transactions_active,
    },
    {
      name: "More",
      link: "/more",
      value: 4,
      iconPath: classes.more_deactive,
      iconActive: classes.more_active,
    },
  ];

  const changeHandler = (index, redirectLink) => {
    setActiveTab(index, redirectLink);
  };

  const setActiveTab = (index, redirectLink) => {
    const currentUrl = redirectLink.replace('/', '');
    
    const { activeTab, changeActiveTab } = props;
  
    let newTab = 0;
  
    switch (currentUrl) {
      case "offers":
        newTab = 1;
        break;
      case "redeem":
        newTab = 2;
        break;
      case "transactions":
        newTab = 3;
        break;
      case "more":
        newTab = 4;
        break;
      default:
        newTab = 0;
    }
    // if (activeTab !== newTab) {
      changeActiveTab(index);
    // }
  };

  return (
    <BottomNavigation
      value={props.activeTab}
      showLabels
      className={classes.bottomNav}
    >
      {routes.map((route) => {
        return (
          <MyBottomNavigationAction
            key={route.value}
            value={route.value}
            to={route.link}
            label={route.name}
            logoutUser={props.logoutUser}
            icon={
              <span
                className={classnames({
                  [route.iconActive]: route.value === props.activeTab,
                  [route.iconPath]: route.value !== props.activeTab,
                  [classes.moreIcon]: route.value === 4,
                  [classes.transactionsIcon]: route.value === 3,
                  [classes.icon]: true,
                })}
              />
            }
            activeTabValue={props.activeTab}
            handleChange={changeHandler}
          />
        );
      })}
    </BottomNavigation>
  );
};

const mapStateToProps = (state) => {
  return {
    activeTab: state.reducerApp.activeTab,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeActiveTab: (id) => dispatch(changeActiveTab(id)),
    logoutUser: () => dispatch(logoutUser()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
